import { secureGet, securePut } from '../utils/HttpUtils';

const apiUrls = {
  sgr: '/v1/private/application/sgr',
};

export interface SgrData {
  logo?: string;
  name: string;
  cuit: string;
  address: string;
  location: string;
  email: string;
  legalRepresentativeName: string;
  legalRepresentativeDni: string;
  legalRepresentativeCuit: string;
  legalRepresentativeEmail: string;
}

export interface SgrResponse {
  success: boolean;
  data?: SgrData;
  message?: string;
}

/**
 * Obtiene los datos de la SGR
 */
export const getSgrData = async (): Promise<SgrResponse> => {
  try {
    const response = await secureGet(apiUrls.sgr);
    if (response.success && 'data' in response && response.data) {
      const raw = response.data as SgrData & { legal_representative_name?: string };
      // Tolerate accidental snake_case from intermediate proxies
      const data: SgrData = {
        logo: raw.logo ?? '',
        name: raw.name ?? '',
        cuit: String(raw.cuit ?? '').trim(),
        address: raw.address ?? '',
        location: raw.location ?? '',
        email: raw.email ?? '',
        legalRepresentativeName:
          raw.legalRepresentativeName ?? raw.legal_representative_name ?? '',
        legalRepresentativeDni: raw.legalRepresentativeDni ?? '',
        legalRepresentativeCuit: raw.legalRepresentativeCuit ?? '',
        legalRepresentativeEmail: raw.legalRepresentativeEmail ?? '',
      };
      return {
        success: true,
        data,
      };
    }
    return {
      success: false,
      message: 'Error al obtener los datos',
    };
  } catch (error: any) {
    console.error('Error getting SGR data:', JSON.stringify(error, null, 2));
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al obtener los datos',
    };
  }
};

/**
 * Actualiza los datos de la SGR
 */
export const updateSgrData = async (data: SgrData): Promise<SgrResponse> => {
  try {
    // Crear copia del objeto sin id, createdAt ni updatedAt
    const { id, createdAt, updatedAt, ...dataToSend } = data as any;
    
    const response = await securePut(apiUrls.sgr, dataToSend);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: response.data,
      };
    }
    return {
      success: false,
      message: response.message || 'Error al actualizar los datos',
    };
  } catch (error: any) {
    console.error('Error updating SGR data:', JSON.stringify(error, null, 2));
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al actualizar los datos',
    };
  }
};
